<template>
  <ml-dialog
    ref="dialogRef"
    title="工单审核"
    width="900px"
    @click-submit="handleSubmit"
    @click-close="handleCancel"
  >
    <template #body>
      <div class="audit-dialog-content">
        <!-- 工单基本信息 -->
        <el-form label-width="120px" style="margin-bottom: 20px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="工单标题:">
                <span>{{ auditData.title }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="所属项目名称:">
                <span>{{ auditData.projectName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="所属阿米巴:">
                <span>{{ auditData.companyName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="参与人员:">
                <span>{{ auditData.dealUserName }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="故障类型:">
                <span>{{ auditData.errorTypeName }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="完工工时:">
                <span>{{ auditData.hours }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="故障结果:">
                <span>{{ auditData.dealResult }}</span>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="工单状态:">
                <el-tag
                  :type="getStatusTagType(auditData.apprStatus)"
                  v-if="getStatusText(auditData.apprStatus)"
                  size="small"
                >
                  {{ getStatusText(auditData.apprStatus) }}
                </el-tag>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="故障描述:">
                <span>{{ auditData.errorDesc }}</span>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="20" v-if="auditData.status">
            <el-col :span="12">
              <el-form-item label="审核状态:">
                <el-tag
                  :type="getAuditStatusTagType(auditData.status)"
                  v-if="getAuditStatusText(auditData.status)"
                  size="small"
                >
                  {{ getAuditStatusText(auditData.status) }}
                </el-tag>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="审核意见:">
                <span>{{ auditData.apprDesc }}</span>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="24">
              <el-form-item label="现场处理图片:">
                <div
                  class="image-list"
                  v-if="auditData.attachVos && auditData.attachVos.length > 0"
                >
                  <div v-for="(img, index) in auditData.attachVos" :key="index" class="image-item">
                    <el-image
                      :src="`${baseUrl}${filePreviewUrl}/${img.filePath}`"
                      fit="cover"
                      class="image-thumbnail"
                      :preview-src-list="[`${baseUrl}${filePreviewUrl}/${img.filePath}`]"
                    >
                      <template #error>
                        <div class="image-error">
                          <i class="el-icon-picture-outline"></i>
                        </div>
                      </template>
                    </el-image>
                  </div>
                </div>
                <div v-else class="no-image">暂无图片</div>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>

        <!-- 审核表单 -->
        <el-form
          ref="auditFormRef"
          v-if="!auditData.apprStatus"
          :model="auditForm"
          :rules="auditFormRules"
          label-width="100px"
        >
          <el-form-item label="审核意见:" prop="opinion">
            <el-input
              v-model="auditForm.opinion"
              type="textarea"
              :rows="3"
              placeholder="请输入审核意见"
            />
          </el-form-item>

          <el-form-item label="审核判定:" prop="result">
            <el-radio-group v-model="auditForm.result">
              <el-radio label="1">有效</el-radio>
              <el-radio label="0">无效</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
    </template>
  </ml-dialog>
</template>

<script>
import { reactive, ref, watch, inject, onMounted, nextTick } from 'vue'
import { useStore } from 'vuex'
import { BASEURL, FILEPREVIEWURL } from '@API'

export default {
  name: 'AuditDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    workOrderId: {
      type: String,
      default: ''
    }
  },
  emits: ['submit', 'close'],
  setup(props, { emit }) {
    const { commit, getters, dispatch } = useStore()
    // 审核表单引用
    const dialogRef = ref(null)
    const auditFormRef = ref()
    const baseUrl = ref(BASEURL)
    const filePreviewUrl = ref(FILEPREVIEWURL)

    // 打开弹窗方法
    const openDialog = () => {
      if (dialogRef.value) {
        dialogRef.value.open()
      }
    }

    // 关闭弹窗方法
    const closeDialog = () => {
      if (dialogRef.value) {
        dialogRef.value.close()
      }
    }

    // 审核表单数据
    const auditForm = reactive({
      opinion: '',
      result: '1'
    })

    // 工单详情数据
    const auditData = ref({
      title: '',
      projectName: '',
      companyName: '',
      participants: '',
      errorType: '',
      hours: '',
      errorDesc: '',
      faultResult: '',
      status: '',
      apprStatus: '',
      apprDesc: '',
      attachVos: []
    })

    // 图片预览相关
    const imageViewerVisible = ref(false)
    const previewImages = ref([])
    const currentPreviewIndex = ref(0)

    // 监听弹窗显示状态，重置表单并加载数据
    watch(
      () => props.visible,
      async newVal => {
        if (newVal && dialogRef.value) {
          // 打开弹窗时重置表单
          auditForm.opinion = ''
          auditForm.result = '1'
          if (auditFormRef.value) {
            auditFormRef.value.clearValidate()
          }
          // 加载工单详情
          await loadWorkOrderDetail()
        }
      }
    )

    // 获取状态文本
    const getStatusText = status => {
      const statusMap = {
        '-1': '待处理',
        0: '无效',
        1: '有效'
      }
      return statusMap[status] || status
    }

    // 获取状态标签类型
    const getStatusTagType = status => {
      const typeMap = {
        '-1': 'warning',
        0: 'info',
        1: 'success'
      }
      return typeMap[status] || ''
    }

    // 获取审核状态文本
    const getAuditStatusText = auditStatus => {
      const statusMap = {
        0: '未审核',
        1: '已审核'
      }
      return statusMap[auditStatus] || auditStatus
    }

    // 获取审核状态标签类型
    const getAuditStatusTagType = auditStatus => {
      const typeMap = {
        0: 'warning',
        1: 'success'
      }
      return typeMap[auditStatus] || ''
    }

    // 加载工单详情
    const loadWorkOrderDetail = async () => {
      console.log('loadWorkOrderDetail', props.workOrderId)
      if (!props.workOrderId) return

      try {
        const { data } = await dispatch('fetchGetWorkOrderDetail', { errorId: props.workOrderId })
        console.log(3232, data)
        auditData.value = data || {}
      } catch (error) {
        console.error('加载工单详情失败:', error)
      }
    }

    // 提交审核
    const handleSubmit = async () => {
      if (!auditFormRef.value) return

      await auditFormRef.value.validate(async valid => {
        if (valid) {
          // 调用父组件的 submit 方法
          const result = await emit('submit', {
            apprDesc: auditForm.opinion,
            apprStatus: auditForm.result
          })

          if (result && result.code === 200) {
            // 成功提示由父组件或拦截器处理
          }
        }
      })
    }

    // 取消
    const handleCancel = () => {
      emit('close')
    }
    onMounted(async () => {
      await nextTick()
      loadWorkOrderDetail()
    })

    return {
      dialogRef,
      auditFormRef,
      auditForm,
      auditData,
      imageViewerVisible,
      previewImages,
      currentPreviewIndex,
      getStatusText,
      getStatusTagType,
      getAuditStatusText,
      getAuditStatusTagType,
      openDialog,
      closeDialog,
      handleSubmit,
      handleCancel,
      baseUrl,
      filePreviewUrl
    }
  }
}
</script>

<style scoped lang="scss">
.audit-dialog-content {
  padding: 10px;
  width: 100%;
  max-height: 500px;
  overflow-y: auto;

  .image-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;

    .image-item {
      width: 100px;
      height: 100px;
      cursor: pointer;
      border-radius: 4px;
      overflow: hidden;
      border: 1px solid #e4e7ed;

      &:hover {
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
      }

      .image-thumbnail {
        width: 100%;
        height: 100%;

        :deep(.image-error) {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 100%;
          background: #f5f7fa;
          color: #909399;
          font-size: 20px;
        }
      }
    }
  }

  .no-image {
    color: #909399;
    font-size: 14px;
  }
}
</style>

<style lang="scss">
.audit-dialog-content {
  .el-form-item {
    margin-bottom: 0;
  }
}

</style>
